import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import {withTranslation} from 'react-i18next';
import { useTranslation } from 'react-i18next';
import {withRouter} from "react-router-dom";
import Layout from '../components/Layout';
import { Image } from 'react-bootstrap';
import moment from 'moment';
import { FlexboxGrid, Col, Grid, Panel, Icon, Divider, Button,  Input, InputGroup, Row, Modal, Dropdown } from 'rsuite';
import TableList from '../components/TableList';

import ModalLocationMap from './reports/ModalLocationMap';

import SearchIcon from '@rsuite/icons/Search';
import GridIcon from '@rsuite/icons/Grid';
import ListIcon from '@rsuite/icons/List';
import HistoryIcon from '@rsuite/icons/History';

import { MdOutlinePersonOutline } from "react-icons/md";
import { MdTagFaces } from "react-icons/md";
import { MdClose } from "react-icons/md";
import { MdOutlineLocationOn } from "react-icons/md";
import { MdManageSearch } from "react-icons/md";
import { MdZoomIn } from "react-icons/md";

const styles = {
	marginBottom: 10
};

const CustomInput = ({ ...props }) => <Input {...props} style={styles} />;

const CustomInputGroup = ({ placeholder, ...props }) => (
  <InputGroup {...props} style={styles}>
    <Input placeholder={placeholder} />
    <InputGroup.Addon>
      <SearchIcon />
    </InputGroup.Addon>
  </InputGroup>
);

const Home = (props)=>{
	const { t } = useTranslation("translations");
	const [listActivities, setListActivities] = useState([]);
	const [listActivitiesAll, setListActivitiesAll] = useState([]);
	const [cardView, setCardView] = useState(true);
	const modal_location_ref = useRef(null);
	const [checkMaxRaduis, setCheckMaxRaduis] = useState(0);
	const [columns, setColumns] = useState([
		{title:'employee', name:'employee', visible:true, width:'30%'},
		{title:'face', name:'face', visible:true, width:'110px'},
		{title:'location', name:'location', visible:true, width:'15%'},
		{title:'date', name:'date', visible:true, width:'15%'},
		{title:'type', name:'type', visible:true, width:'15%'},
		{title:'evidence', name:'evidence', visible:true, width:'10%'}
	])
	const [list, setList] = useState([]);
	const table_ref = useRef(null);
	const [showModalLocation, setShowModalLocation] = useState(false);
	const [currentLat, setCurrentLat] = useState('');
	const [currentLng, setCurrentLng] = useState('')
	const [currentName, setCurrentName] = useState('');
	const [showPhotoModal, setShowPhotoModal] = useState(false);
	const [photoItem, setPhotoItem] = useState(null);

	const [userType, setUserType] = useState(sessionStorage.getItem('userType'))
	const [loaded, setLoaded] = useState(false);
	//reports/visit/details/679a64fb7ec4b31b96d13713

	useEffect(() => {
		//let user = sessionStorage.getItem('userType');

		if (userType !== 'contractor') {
			GetAllowedDistance();
		}


    }, []);

	// TableList sólo existe en el DOM cuando cardView===false, y hay que
	// (re)inicializar el plugin de DataTables cada vez que cambian los datos
	// o se entra a la vista de lista — si no, queda una <table> sin buscador,
	// export ni paginación. useLayoutEffect (no useEffect) a propósito: useEffect
	// corre DESPUÉS de que el navegador ya pintó, así que alcanza a mostrarse
	// un frame de la tabla cruda de React antes de que DataTables la envuelva
	// — useLayoutEffect corre en el mismo ciclo de commit, antes del pintado.
	useLayoutEffect(() => {
		if (!cardView && table_ref.current) {
			table_ref.current.resetTable();
			table_ref.current.setTable();
			// Si el modal de carga seguía abierto (fetch inicial en curso), se
			// cierra recién aquí — cuando la tabla real ya está lista, no
			// apenas llega la respuesta — para no mostrar el flash de la
			// tabla cruda sin estilos/buscador/paginación (mismo estándar
			// aplicado en Employee.js).
			props.modal_loader.handleClose();
		}
	}, [cardView, list]);

	const GetAllowedDistance = async() => {
        var accountId  = atob(sessionStorage.getItem(btoa('account_id')));
        accountId = accountId.substring(1, accountId.length - 1);

		//console.log(accountId);
		if (!accountId || accountId === 'ul') {
			console.log('sin cuenta')
			return
		}

		var req = {
            api:'accounts',
            method:'GET',
            url:'accounts/'+accountId,
            requireToken:true,
        }
		props.modal_loader.handleShow()
		let response =  await props.fetchRequest(req);

		if(response !== null&& response !== undefined){
			//console.log(response);
			let dis = response.accountConfig && response.accountConfig.checkMaxRaduis? response.accountConfig.checkMaxRaduis : 0;
			setCheckMaxRaduis(dis)
			await FetchData(dis);
			// En vista de tarjetas no hay tabla/DataTables que inicializar,
			// así que se cierra de inmediato; en vista de lista lo cierra el
			// useEffect de arriba una vez que la tabla ya está lista.
			if (cardView) {
				props.modal_loader.handleClose();
			}
			const intervalId = setInterval(() => {
				
				if (sessionStorage.getItem('token')) {
					//console.log('interval');
					//console.log(sessionStorage.getItem('token'))
					FetchData(dis);
				}
				
			}, 60000/**5*/);
			
			return () => {
				clearInterval(intervalId);
			};
		}

		props.modal_loader.handleClose();
	}

	const FetchData = async(dis) => {
		var accountId  = atob(sessionStorage.getItem(btoa('account_id')));
        accountId = accountId.substring(1, accountId.length - 1);
		let allowed = dis? dis : checkMaxRaduis;

		let userType = sessionStorage.getItem('userType')

		var req = {
            api:'reports',
            method:'POST',
            url:'reports/employees-activity/'+accountId,
            requireToken:true,
			obj:{
				locationId: userType === 'client'? sessionStorage.getItem('locationId') : null
			}
        }
		
        let response =  await props.fetchRequest(req);

		if(response !== null&& response !== undefined){
			//var list = [];
			response.map((col, i) => {
				let meters = col.metersFromLocation? col.metersFromLocation : 0;
				col.showLocation = meters <= allowed? false : true;
				col.checkLabel = t('screen.reports.employees_activity.check_type_label_'+col.checkType, { defaultValue: col.checkType || '' })
				col.isEntry = col.checkType === 'in' || col.checkType === 'visit-in' || col.checkType === 'overtime-in';
				col.checkTimeShort = moment(col.localCheckTime).format('DD/MM HH:mm');
				col.localCheckTime = moment(col.localCheckTime).format('DD/MM/YYYY HH:mm');
				/*list.push([
					col.employeeName,
					col.validFace ? 
                        'icon/MdDone/green/entry/no_action'
                    	: 'icon/MdClose/red/entry/no_action',
					meters <= allowed?
						'icon/'+col.location+'/#7E7E7E/no_location/one/'+
                        col.latitude+'/'+col.longitude
						:'icon/MdOutlineLocationOn/'+'red/start_location/one/' +
                        col.latitude+'/'+col.longitude,
					col.localCheckTime,
					col.checkLabel,
					col.checkType === 'visit-out'?  "icon/MdManageSearch/"+('var(--primary)')+"/evidence/"+(col.checkType === 'visit-out'? 'one' : 'no_action') : ''
				])*/
			})
			//console.log(response)
			setListActivities(response);
			setListActivitiesAll(response);
			//setList(list)
			FetchTable(response, dis)
		}
		setLoaded(true);

		
	}

	const FetchTable = (response, dis) => {
		let allowed = dis? dis : checkMaxRaduis;
		if(response !== null&& response !== undefined){
			var list = [];
			response.map((col, i) => {
				let meters = col.metersFromLocation? col.metersFromLocation : 0;
				/*col.showLocation = meters <= allowed? false : true;
				col.checkLabel = t('screen.reports.employees_activity.check_type_label_'+col.checkType)
				col.localCheckTime = moment(col.localCheckTime).format('DD/MM/YYYY HH:mm');*/
				list.push([
					col.employeeName,
					col.validFace ?
                        'icon/MdDone/green/entry/no_action'
                    	: 'icon/MdClose/red/entry/no_action',
					meters <= allowed?
						'icon/'+(col.location || t('screen.reports.employees_activity.no_location'))+'/#7E7E7E/no_location/one/'+
                        col.latitude+'/'+col.longitude
						:'icon/MdOutlineLocationOn/'+'red/start_location/one/' +
                        col.latitude+'/'+col.longitude,
					col.localCheckTime,
					'type/'+col.checkLabel+'/'+(col.isEntry ? 'in' : 'out'),
					col.checkType === 'visit-out'?  "icon/MdManageSearch/"+('var(--primary)')+"/evidence/"+(col.checkType === 'visit-out'? 'one' : 'no_action') : ''
				])
			})
			//console.log(response)
			//setListActivities(response);
			// DataTables (fixedColumns) clona/mueve nodos del <table> fuera de su
			// posición original en el DOM. Si React re-renderiza el <tbody> con
			// datos nuevos (p. ej. al escribir en el buscador) sin que la
			// instancia de DataTables se destruya antes, React intenta quitar un
			// nodo que ya no está donde cree — "removeChild: not a child of this
			// node". Hay que destruirla ANTES de actualizar el estado.
			if(table_ref.current){
				table_ref.current.resetTable();
			}
			setList(list)
		}
	}

	const actionIcon = (e, i, d) => {
		//console.log(e)
		console.log(i)
		console.log(d)

		if (d === 'evidence') {
			GoToVisitDetails(listActivities[i]);
		} else {
			OpenModalMap(listActivities[i])
		}
		
	}

	const FilterData = async(filter) => {
		//console.log(filter)
		if (filter && filter !== "") {
			//console.log('filtrar')
			var fils = listActivitiesAll.filter(function(item) {
				var name = item.employeeName ? item.employeeName.toString().toLowerCase() : '';
				var loc = item.location ? item.location.toString().toLowerCase() : '';

				if (name.includes(filter.toLowerCase()) || loc.includes(filter.toLowerCase())) {
					return true;
				}else {
					return false
				}

			});
		}else {
			//console.log('sin')
			var fils = listActivitiesAll;
		}

		//console.log(fils)
		setListActivities(fils)
		FetchTable(fils, null)
	}

	

	const GoToVisitDetails = (item) => {
		//67ae35c515b44e2e8d2636ed
		let url = "/reports/visit/details/"+item.visitId;
		//console.log(url)
		//props.history.push(url);
		props.history.push({                
			pathname: url,
			state: { 
				origin: 'home'
			}
		});
	}

	const OpenModalMap = (item) => {
		//console.log(modal_location_ref);
		setCurrentLat(item.latitude);
		setCurrentLng(item.longitude);
		setCurrentName(item.employeeName)
		setShowModalLocation(true);
		//modal_location_ref.current.handleShow(item.latitude, item.longitude, item.name)
	}

	const CloseModalMap = () => {
		console.log('cerrar')
		setCurrentLat('');
		setCurrentLng('');
		setCurrentName('')
		setShowModalLocation(false);
	}

	const OpenPhotoModal = (item) => {
		setPhotoItem(item);
		setShowPhotoModal(true);
	}

	const ClosePhotoModal = () => {
		setShowPhotoModal(false);
		setPhotoItem(null);
	}

	return (
		<Layout {...props}>
			{userType !== 'contractor' &&
			<>
			<h3 className="s-title-page">{t('screen.reports.employees_activity.title')}</h3>
			
			<Grid fluid style={{marginBottom:'16px'}}>
				<Col xs={18}>
					<span>{t('screen.reports.employees_activity.last_hours')}</span>
					<HistoryIcon style={{marginLeft:'10px'}} className='iconHome' 
						onClick={()=>{
							//console.log('reload')
							FetchData()

						}}
					/>
				</Col>
				<Col xs={6} style={{textAlign:'right'}}>
					<div className="view-toggle">
						<button
							type="button"
							className={"view-toggle-btn"+(!cardView ? " is-active" : "")}
							title={t('general.table.list_view')}
							onClick={() =>{
								setCardView(false);
							}}
						>
							<ListIcon />
						</button>
						<button
							type="button"
							className={"view-toggle-btn"+(cardView ? " is-active" : "")}
							title={t('general.table.card_view')}
							onClick={() =>{
								setCardView(true);
							}}
						>
							<GridIcon />
						</button>
					</div>
				</Col>
			</Grid>
			<Grid fluid>
				<Col xs={5}>
					<CustomInputGroup size="md" placeholder={t('general.table.search')}
						onChange= {(e) => {
							console.log(e.target.value);
							FilterData(e.target.value)
						}}
					/>
				</Col>
				{!cardView &&
					<Col xs={19} style={{textAlign:'right'}}>
						<Dropdown
							title={t('general.table.export')}
							placement="bottomEnd"
							className="export-dropdown"
						>
							<Dropdown.Item onClick={()=> table_ref.current && table_ref.current.triggerButton('buttons-excel')}>
								Excel
							</Dropdown.Item>
							<Dropdown.Item onClick={()=> table_ref.current && table_ref.current.triggerButton('buttons-pdf')}>
								PDF
							</Dropdown.Item>
						</Dropdown>
					</Col>
				}
			</Grid>
			<Grid fluid>
				{cardView === true?
					<>
					{loaded && listActivities.length === 0 ?
						<div className="activity-empty">
							<MdOutlinePersonOutline className="activity-empty-icon" />
							<span className="activity-empty-title">{t('screen.reports.employees_activity.empty_title')}</span>
							<span className="activity-empty-text">{t('screen.reports.employees_activity.empty_text')}</span>
						</div>
					:
					<ul className='cards'>
					{listActivities.map((item, i) => {
						return (
							<Panel className='cards_item' key={i}>
								<Panel shaded bordered className="panel-report activity-card">
									<div className="activity-card-photo-top" onClick={()=>{ OpenPhotoModal(item) }}>
										<img src={item.urlCheckFace} alt={item.employeeName} />
										<span className="activity-photo-zoom"><MdZoomIn /></span>
										<MdTagFaces className={"activity-face-badge "+(item.validFace ? 'is-valid' : 'is-invalid')} />
									</div>
									<div className="activity-card-body">
										<span className="activity-card-name" title={item.employeeName}>{item.employeeName}</span>
										<div className="activity-card-header">
											<span className={"activity-pill "+(item.isEntry ? 'is-in' : 'is-out')} title={item.checkLabel}>{item.checkLabel}</span>
											<span className="activity-card-time">{item.checkTimeShort}</span>
										</div>
										<div className="activity-card-location">
												{!item.showLocation ?
													<span className="activity-location labelLocation" title={item.location}
														onClick={()=>{ OpenModalMap(item) }}
													>
														<MdOutlineLocationOn className="activity-location-icon" />
														{item.location}
													</span>
													:
													<span className="activity-location is-warning" title={t('screen.reports.employees_activity.out_of_range')}
														onClick={()=>{ OpenModalMap(item) }}
													>
														<MdOutlineLocationOn className="activity-location-icon is-warning" />
														{t('screen.reports.employees_activity.out_of_range')}
													</span>
												}
												{item.checkType === 'visit-out' &&
													<MdManageSearch className="activity-evidence-icon"
														title={t('button.download_evidences')}
														onClick={()=>{ GoToVisitDetails(item) }}
													/>
												}
											</div>
										</div>
								</Panel>
							</Panel>
						)
					})}
					</ul>
					}
					</>
					:
					<>
						<Col xs={24}>
                            <TableList 
                                //{...this.props} 
								t={t}
                                onRef={ref => { table_ref.current = ref; }}
                                columns={columns}
                                btnNew={false}
                                data={list}
                                actions={[]}
                                actionIcon={actionIcon}
                                //updateColumns={updateColumns}
                                screen={"employees_activity"}
                                searching={false}
                                report={true}
                                table_title={[]}
                                //filename={t('screen.reports.'+filename)}
                                scroll={true}
                                scrollY="calc(100vh - 300px)"
                                widths={['25%','15%','10%','15%','10%','10%','15%']}
                                //search={this.search}
                                //downloadEvidences={downloadEvidences}
								
                            />
                        </Col>
					</>
				}
			</Grid>
			</>}

			{showModalLocation &&
				<ModalLocationMap
					open={showModalLocation}
					close={CloseModalMap}
					lat={currentLat}
					lng={currentLng}
					name={currentName}
					ref={modal_location_ref}
				/>
			}

			<Modal size="sm" show={showPhotoModal} onHide={ClosePhotoModal} className="activity-photo-modal">
				<Modal.Header>
					<Modal.Title>{photoItem ? photoItem.employeeName : ''}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{photoItem &&
						<div className="activity-photo-modal-body">
							<img src={photoItem.urlCheckFace} alt={photoItem.employeeName} />
							<div className="activity-photo-modal-meta">
								<span className={"activity-pill "+(photoItem.isEntry ? 'is-in' : 'is-out')}>{photoItem.checkLabel}</span>
								<span className="activity-card-time">{photoItem.localCheckTime}</span>
							</div>
						</div>
					}
				</Modal.Body>
			</Modal>

		</Layout>
	)
}

export default withTranslation('translations') (Home);